import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsModalComponent } from "./ds-modal.component";
import { DsButtonModule } from "../ds-button/ds-button.module";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsModalComponent],
  imports: [CommonModule, DsButtonModule, DsIconModule],
  exports: [DsModalComponent],
})
export class DsModalModule {}
